module.exports = __webpack_public_path__ + "img/博野油漆与胶带.73bc136e.jpg";